var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.readonly ? _c('Warning', {
    attrs: {
      "icon": "mdi-lock"
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate("readonlyAccountMessage")) + " "), _c('v-row', {
    staticClass: "mt-2 d-flex align-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "3"
    }
  }, [_c('Button', {
    staticClass: "w-100 w-sm-auto",
    attrs: {
      "text": _vm.$translate('contactUs'),
      "color": 'primary',
      "icon": "email"
    },
    on: {
      "click": _vm.sendMail
    }
  })], 1)], 1)], 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }